import { render, staticRenderFns } from "./color-tip.vue?vue&type=template&id=451d2de6&scoped=true&"
import script from "./color-tip.vue?vue&type=script&lang=js&"
export * from "./color-tip.vue?vue&type=script&lang=js&"
import style0 from "./color-tip.vue?vue&type=style&index=0&id=451d2de6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "451d2de6",
  null
  
)

export default component.exports